import React, { useState } from 'react';

import Portal from 'components/application/Portal';

import MasterCoshhBackButton from 'components/masterCoshh/components/MasterCoshhBackButton';
import MasterCoshhTable from 'components/masterCoshh/components/MasterCoshhTable';

export default function MasterCoshhIndex() {
  const [hasCoshhDocumentBeenChanged, setHasCoshhDocumentBeenChanged] =
    useState(false);

  return (
    <>
      <MasterCoshhTable
        onCoshhDocumentChange={() => setHasCoshhDocumentBeenChanged(true)}
      />
      <Portal containerSelector='.coshh-back-button'>
        <MasterCoshhBackButton
          hasCoshhDocumentBeenChanged={hasCoshhDocumentBeenChanged}
        />
      </Portal>
    </>
  );
}
